import axios from 'axios'
import jwtToken from './getJwtToken'
import { errorHandler } from './errorHandler'
import { locale } from './locale'

const DASHBOARD_API_URL = process.env.VUE_APP_DASHBOARD_API_URL

const dashboardApi = axios.create({
  baseURL: `${DASHBOARD_API_URL}/api/`,
  headers: {
    Authorization: `Bearer ${jwtToken}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Accept-Language': locale,
  },
})

dashboardApi.interceptors.response.use(
  response => response,
  error => errorHandler(error),
)

dashboardApi.interceptors.request.use(
  request => request,
  error => errorHandler(error),
)

export default dashboardApi
